import React from "react";
import { Button } from "react-bootstrap";

// Change the membership status of a Lockbox member
// Lockbox instance (this.state.lockbox) is passed into to props as props.lockbox
// Address of sender (this.state.address) is passed into props as props.address
function ChangeMembershipTab(props) {

    const handleChangeMembers = (event) => {
        event.preventDefault()
        changeMembers(event.target.memberAdd.value, event.target.action.value)
    }


    const changeMembers = async (memberAdd, action) => {
        await props.lockbox.methods.modifyMember(memberAdd, action).send({ from: props.address });
    }

    return (
        <form onSubmit={handleChangeMembers}>
            <label>Add/Remove Member</label>
            <br />
            <input type="text" name="memberAdd" className="form-control w-25 center-block"></input>
            <br />
            <label>Input 1 to add to membership or 0 to remove from membership.</label>
            <br />
            <input type="number" step="1" min="0" max="1" name="action" className="form-control w-25 center-block"></input>
            <br />
            <br />
            <Button variant="dark" type="submit">Submit Change</Button>
        </form>
    )
}

export default ChangeMembershipTab
